var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.144,
    height: 76.98,
    viewBox: "0 0 92.144 76.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Roles",
    transform: "translate(-47.579 -913.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19023",
    "data-name": "Trazado 19023",
    d: "M84.178,933.793a11.847,11.847,0,1,1-23.678,0v-7.016a11.847,11.847,0,1,1,23.678,0Z",
    transform: "translate(35.084 0)",
    fill: "#95d4e9",
    stroke: "#163567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1752",
    "data-name": "Elipse 1752",
    cx: 9.866,
    cy: 9.866,
    r: 9.866,
    transform: "translate(66.264 920.419)",
    fill: "none",
    stroke: "#163567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19024",
    "data-name": "Trazado 19024",
    d: "M95.584,930.184a29.914,29.914,0,0,0-46.9,18.5,4.934,4.934,0,0,0,4.936,5.734H78.049",
    transform: "translate(0 23.225)",
    fill: "none",
    stroke: "#163567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19025",
    "data-name": "Trazado 19025",
    d: "M86.864,925.5h0a31.578,31.578,0,0,0-31.255,27.084,3.97,3.97,0,0,0,3.942,4.487h54.625a3.97,3.97,0,0,0,3.942-4.487A31.578,31.578,0,0,0,86.864,925.5Z",
    transform: "translate(20.56 32.409)",
    fill: "none",
    stroke: "#163567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/Roles.445dcd13ba2c3c165ca6b3b08fec3938.svg";
export { ForwardRef as ReactComponent };